import { ImgHTMLAttributes } from 'react';

export default function BaseImage(props: ImgHTMLAttributes<HTMLImageElement>) {
  const { alt = '', ...restProps } = props;

  return <img alt={alt} {...restProps} />;
}
